import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Ru from '@/locales/ru';
import En from '@/locales/en';
import Cn from '@/locales/cn';

Vue.use(VueI18n);


export default new VueI18n({
  locale: localStorage.getItem('current-language'),
  messages: {
    ru: Ru,
    en: En,
    cn: Cn,
  },
});
